const mouthMass = 
[
    {label:"Size (cm)",
    controlType:"text",
    options:[]
    },

   {label:"Side",
    controlType:"checkbox group",
    options:["Right", "Left", "Central"]
    },

    {label:"Site",
    controlType:"checkbox group",
    options:["Upper lip", "Lower lip", "Lower gum", "Upper Gum", "Inner cheek", "Palatte", "Anterior tongue", "Posterior tongue", "Mouth floor", "Tonsil", "Oropharynx"]
    },

    { 
    label:"Mass or Ulcer",
    controlType:"radio button",
    options:["Mass", "Ulcer", "Ulcerated Mass"]
    },
    
    { 
    label:"Consistency:",
    controlType:"radio button",
    options:["Hard", "Soft"]
    },

    { 
    label:"Shape:",
    controlType:"radio button",
    options:["Smooth", "Irregular"]
    },

    { 
    label:"Pain:",
    controlType:"radio button",
    options:["Painful", "Painless"]
    },

    { 
    label:"Tenderness:",
    controlType:"radio button",
    options:["Tender", "Non-tender"]
    },

    { 
    label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }
    
]


export default mouthMass